<template>
    <div class="view-container">
        <modal :showDialog="activeModal === 'DELETE'" @close="closeModal" :title="$t('DELETEREQUIREMENT')">
            <delete-confirm @cancel="closeModal" @confirm="deleteRequirementConfirm" :text="actionText"></delete-confirm>
        </modal>
        <Modal :title="$t('AddRequirement').toUpperCase()" :showDialog="activeModal === 'ADD'" @close="openModal(null, null)">
            <add-requirement @cancel="closeModal" @saved="closeModal(true)"/>
        </Modal>
        <Modal :title="$t('EditRequirement').toUpperCase()" :showDialog="activeModal === 'EDIT'" @close="openModal(null, null)">
            <edit-requirement :current="selectedRequirementId" @cancel="closeModal" @saved="closeModal(true)"/>
        </Modal>
        <Modal :title="$t('DownloadProgress')" :showDialog="activeModal == 'Progress'" @close="cancelDownload">
            <div class="progress-container vertical" style="min-width: 30vw;">
                <ProgressBar :loaded="bytesReceived" :total="bytesToReceive"/>
                <button class="cancel-button semi-bold" style="margin-top: 12px;" @click="cancelDownload">{{ $t('Cancel') }}</button>
            </div>
        </Modal>
        <div id="snackbar">{{ $t('Copied') }}</div>
        <div>
            <div class="max-grid">
                <ejs-grid ref="grid" height='100%' width='100%' :toolbar='toolbar' :toolbarClick='toolbarClick' :selectionSettings='selectionOptions' :allowTextWrap="true" :textWrapSettings='wrapSettings' :dataBound='dataBound' :dataSource="requirements" :allowPaging="true" :pageSettings='pageSettings' :allowFiltering='true' :filterSettings='filterOptions' :allowSorting='true' :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true">
                    <e-columns>
                        <e-column field='program' :headerText="$t('Program')" textAlign='Left' :filter="filterCheckBox" :customAttributes="customAttributes"></e-column>
                        <e-column field='platform' :headerText="$t('Platform')" textAlign='Left' :filter="filterCheckBox" :customAttributes="customAttributes"></e-column>
                        <e-column field='maxVersion' :headerText="$t('MaxVersion')" textAlign='Left' :customAttributes="customAttributes"></e-column>
                        <e-column field='id' headerText="" width="150px" :allowSorting="false" :allowFiltering="false" :template="optionsTemplate"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import { getRequirementsList, getRequirementById, deleteRequirement } from '@api';
import axios from 'axios';
import ProgressBar from '@/components/ProgressBar.vue';
import { parseProgress } from '@/util/progress';

import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';

import ProbablyOverflowingTextCell from '../../components/Systems/ProbablyOverflowingTextCell.vue';
import Modal from '../../components/Modal.vue';
import AddRequirement from '../../components/Software/AddRequirement.vue';
import EditRequirement from '../../components/Software/EditRequirement.vue';
import DeleteConfirm from '../../components/DeleteConfirm.vue';

import Vue from "vue";

var context = null;

export default {
    components: {
        ProbablyOverflowingTextCell,
        Modal,
        AddRequirement,
        EditRequirement,
        DeleteConfirm,
        ProgressBar
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
            requirements: [],
            // PROGRESS
            bytesReceived: 0,
            bytesToReceive: 0,
            downloadController: null,
            // VIEW MANAGEMENT
            activeModal: null,
            activeData: null,
            selectedRequirementId: null,
            actionText: null,
            // GRID 
            dateTimeFormatOptions: { format: 'yyyy-MM-dd', type: 'dateTime' },
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [
                { text: this.$t('AddRequirement'), tooltipText: 'Add Requirement', prefixIcon: 'e-add', id: 'addRequirement', align: 'Left' },
                'Search'
            ],
            wrapSettings: { wrapMode: 'Header' } ,
            selectionOptions: { type: 'Multiple' },
            filterOptions: {
                type: 'Menu'
            },
            filterCheckBox: {
                type: 'CheckBox',
            },
            customAttributes: { class: 'customcss' },
            optionsTemplate: function() {
                return {
                    template: Vue.component('optionsTemplate', {
                        template: `
                            <div class="horizontal grow">
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('Copy')" :content="$t('CopyLink')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21 8C21 6.34315 19.6569 5 18 5H10C8.34315 5 7 6.34315 7 8V20C7 21.6569 8.34315 23 10 23H18C19.6569 23 21 21.6569 21 20V8ZM19 8C19 7.44772 18.5523 7 18 7H10C9.44772 7 9 7.44772 9 8V20C9 20.5523 9.44772 21 10 21H18C18.5523 21 19 20.5523 19 20V8Z" fill="#346F8B"/>
                                        <path d="M6 3H16C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1H6C4.34315 1 3 2.34315 3 4V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V4C5 3.44772 5.44772 3 6 3Z" fill="#346F8B"/>
                                    </svg>
                                </div>
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('Download')" :content="$t('Download')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                   <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 21H18M12 3V17M12 17L17 12M12 17L7 12" stroke="#346F8B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                </div>
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('Edit')" :content="$t('Edit')" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.64951 16.4004L7.64952 16.4003M7.64951 16.4004L7.64951 16.4004L7.64952 16.4003M7.64951 16.4004C7.64952 16.4004 7.64952 16.4003 7.64952 16.4003M7.64951 16.4004L7.64952 16.4003M14.95 7.25429L17.4952 9.61783L10.5666 16.0519L7.66216 16.3496L7.66203 16.3496C7.65971 16.3499 7.65755 16.35 7.65555 16.35L7.96842 13.737L14.95 7.25429ZM18.5296 4.83337L20.1732 6.35962C20.4089 6.57848 20.4091 6.91217 20.1731 7.13143L19.0692 8.15645L16.524 5.79293L17.5573 4.83337C17.8206 4.58888 18.2663 4.58888 18.5296 4.83337Z" stroke="#346F8B" stroke-width="1.3"/></svg>
                                </div>
                                <div style="cursor: pointer; margin: 5px" v-on:click="onClick('DELETE')" content="${context.$t('Delete')}" v-tippy="{ theme : 'customTheme', placement : 'left', arrow : true }">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 1.4C3.5 0.626801 4.1268 0 4.9 0H9.1C9.8732 0 10.5 0.626801 10.5 1.4V2.8H11.8928C11.8971 2.79996 11.9014 2.79996 11.9058 2.8H13.3C13.6866 2.8 14 3.1134 14 3.5C14 3.8866 13.6866 4.2 13.3 4.2H12.5518L11.9447 12.6997C11.8923 13.4324 11.2827 14 10.5482 14H3.45178C2.71729 14 2.10767 13.4324 2.05534 12.6997L1.44822 4.2H0.7C0.313401 4.2 0 3.8866 0 3.5C0 3.1134 0.313401 2.8 0.7 2.8H2.09422C2.09856 2.79996 2.1029 2.79996 2.10722 2.8H3.5V1.4ZM4.9 2.8H9.1V1.4H4.9V2.8ZM2.85178 4.2L3.45178 12.6H10.5482L11.1482 4.2H2.85178ZM5.6 5.6C5.9866 5.6 6.3 5.9134 6.3 6.3V10.5C6.3 10.8866 5.9866 11.2 5.6 11.2C5.2134 11.2 4.9 10.8866 4.9 10.5V6.3C4.9 5.9134 5.2134 5.6 5.6 5.6ZM8.4 5.6C8.7866 5.6 9.1 5.9134 9.1 6.3V10.5C9.1 10.8866 8.7866 11.2 8.4 11.2C8.0134 11.2 7.7 10.8866 7.7 10.5V6.3C7.7 5.9134 8.0134 5.6 8.4 5.6Z" fill="#346F8B"/></svg>
                                </div>
                            </div>
                        `,
                        data: function(){
                            return {
                                data: {}
                            }
                        },
                        methods: {
                            onClick(mode) {
                                switch(mode) {
                                    case 'Download':
                                        context.downloadRequirement(this.data);
                                        break;
                                    case 'DELETE':
                                        context.deleteRequirement(this.data);
                                        break;
                                    case 'Edit': 
                                        context.openEditModal(this.data);
                                        break;
                                    case 'Copy':
                                        context.copyLink(this.data);
                                }
                            }
                        }
                    })
                }
            },
            TextTemplate: function () {
				return {
					template: {
						extends: ProbablyOverflowingTextCell,
					},
				};
			},
        }
    },
    methods: {
        copyLink(software) {
            navigator.clipboard.writeText(Vue.prototype.$http.defaults.baseURL + `Updater/requirement/${software.id}`);
            var x = document.getElementById("snackbar");
            x.className = "show";
            x.innerHTML = `${context.$t('Copied')} - ${software.fileName}`
            setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
        },
        async getData() {
            var requirementsList = await getRequirementsList();
            // console.dir(requirementsList)
            this.requirements = [...requirementsList]
        },
        toolbarClick(args) {
            switch(args.item.id){
                case 'addRequirement':
                    this.openModal(null, 'ADD')
                    break;
            }
        },
        dataBound() {
            this.$refs.grid.autoFitColumns();
        },
        openModal(data, modal) {
            this.activeModal = modal;
            this.activeData = data;
        },
        async closeModal(isGetData) {
            if (isGetData) {
                await this.getData();
            }

            this.actionText = null;
            this.selectedRequirementId = null;

            this.openModal(null, null);
        },
        openEditModal(selectedRequirement) {
            this.activeModal = 'EDIT';
            this.selectedRequirementId = selectedRequirement;
        },
        async downloadRequirement(requirement) {
            this.activeModal = 'Progress';
            this.bytesReceived = 0;
            this.bytesToReceive = 0;
            this.downloadController = new AbortController();

            var followConfig = {
                signal: this.downloadController.signal,
                onDownloadProgress: progressEvent => {
                    const { loaded, total } = parseProgress(progressEvent, requirement.fileSize);
                    context.bytesReceived = loaded;
                    context.bytesToReceive = total;
                }
            };

            try {
                var blob = await getRequirementById(requirement.id, followConfig);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";

                var url = window.URL.createObjectURL(blob.data);
                a.href = url;
                a.download = requirement.fileName;
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            } catch (e) {
                if (!axios.isCancel(e)) {
                    console.dir(e);
                }
            } finally {
                this.activeModal = null;
                this.downloadController = null;
            }
        },
        cancelDownload() {
            if (this.downloadController) {
                this.downloadController.abort();
            }
            this.activeModal = null;
        },
        async deleteRequirement(version) {
            this.actionText = `Delete version: ${version.program} | ${version.platform} | ${version.maxVersion}`
            this.activeModal = 'DELETE';
            this.selectedRequirementId = version.id;
        },
        async deleteRequirementConfirm() {
            await deleteRequirement(this.selectedRequirementId);
            this.closeModal(true)
        }
    },
    async mounted () {
        context = this;
        this.getData();
    },
}
</script>

<style scoped>
.progress-container {
    margin: 10px 20px;
}

#upload-progress {
    height: 20px;
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/Software/SoftwareRequirements.vue